import * as React from 'react';
import Modal from "react-responsive-modal";
import Input from '../../../../../common/Input/Input'
import InputUtils, {Type} from "../../../../../../InputUtils";
import Utils from "../../../../../../Utils";
import {AxiosPromise} from "axios";
import toastr from "toastr";
import '../createUserModal/createUserModalStyles.css'

interface IState {
    validateForm: boolean;
    form: any,
}

interface IProps {
    showSetPassModal: boolean;

    closeSetPassModal(): void;

    refreshGrid(): void;

    setNewPassRequest(dto: any): AxiosPromise;

    selectedUser: any
}

class SetUserPasswordModal extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            validateForm: false,
            form: {
                password: {
                    value: '',
                    valid: true,
                    errorMsg: 'Password length must be at least 4 characters',
                },
                confirmPass: {
                    value: '',
                    valid: true,
                    errorMsg: 'Passwords do not match',
                },
            }
        };
    }

    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any) {
        if (this.props.showSetPassModal && this.props.showSetPassModal !== prevProps.showSetPassModal) {
            document.addEventListener('keydown', this.keydownModalHandler);
        }
        if (this.props.showSetPassModal !== prevProps.showSetPassModal && !this.props.showSetPassModal) {
            document.removeEventListener('keydown', this.keydownModalHandler);
        }
    }

    componentWillUnmount(): void {
        document.removeEventListener('keydown', this.keydownModalHandler);
    }

    keydownModalHandler = (e) => {
        if (e.keyCode === 13) {
            Utils.$('#btn-set-new-pass').click();
        }
    }

    onChange = (event, id) => {
        const eventValue = event.target.value;

        this.setState({
            form: {
                ...this.state.form,
                [id]: {
                    ...this.state.form[id],
                    value: eventValue,
                    valid: true
                }
            }
        })
    }

    close = () => {
        this.resetForm();
        this.props.closeSetPassModal();
    }

    resetForm = () => {
        this.setState({
            form: InputUtils.resetForm(this.state.form)
        })
    }

    checkFormValidity = (): boolean => {
        const keys = Object.keys(this.state.form);
        const formCopy = JSON.parse(JSON.stringify(this.state.form));
        let formIsValid = true;
        keys.forEach((key, index) => {
            switch (key) {
                case 'password':
                    const pass = formCopy[key].value;
                    if (this.props.selectedUser && !InputUtils.PASSWORD_REGEX.test(pass)) {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break;
                case 'confirmPass':
                    if (this.props.selectedUser && formCopy[key].value !== formCopy[keys[index - 1]].value) {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break;
            }
        })

        this.setState({
            form: formCopy
        })

        return formIsValid;
    }

    inviteUserHandler = () => {
        if (this.checkFormValidity()) {
            const dto = {
                password: this.state.form.password.value,
            }

            this.props.setNewPassRequest(dto)
                .then(() => {
                    this.props.refreshGrid();
                    this.close();
                    toastr.success('User password updated successfully');
                })
                .catch((requestError) => {
                    console.error(requestError);
                })
        }
    }

    render() {
        return (
            <Modal
                open={this.props.showSetPassModal}
                styles={{
                    overlay: {zIndex: 10000},
                    closeButton: {display: "none"},
                    modal: {
                        width: 600,
                        padding: 0,
                        maxWidth: 600,
                    }
                }}
                closeOnEsc={true}
                onClose={this.close}
                center
                focusTrapped={true}
                closeOnOverlayClick={false}
            >
                <div style={{width: '100%', height: '85%', backgroundColor: "#2B2B2B"}}>
                    <div className="row" style={{height: '100%'}}>
                        <div id={'create-user-container'} className='col-lg-12 compare-changes'>
                            <header className={'create-user-modal-header'}>
                                <h2>Set New Password</h2>
                            </header>
                            <div style={{minHeight: 190}} className={'edit-user-modal-container'}>
                                <div className={'createUserForm'}>
                                    <Input id={'password'}
                                           value={this.state.form.password.value}
                                           required={true}
                                           elementType={Type.INPUT}
                                           changed={(event) => this.onChange(event, 'password')}
                                           classNameProp={'input-full-width default-margin-inputs'}
                                           valid={this.state.form.password.valid}
                                           errorMsg={this.state.form.password.errorMsg}
                                           label={'New Password'}
                                           elementConfig={{
                                               placeholder: 'New Password',
                                               tabIndex: 1,
                                               type: 'password',
                                               autocomplete: "new-password"
                                           }}
                                    />
                                    <Input id={'confirmPass'}
                                           value={this.state.form.confirmPass.value}
                                           required={true}
                                           elementType={Type.INPUT}
                                           changed={(event) => this.onChange(event, 'confirmPass')}
                                           classNameProp={'input-full-width default-margin-inputs'}
                                           errorMsg={this.state.form.confirmPass.errorMsg}
                                           label={'Confirm Password'}
                                           valid={this.state.form.confirmPass.valid}
                                           elementConfig={{
                                               placeholder: 'Confirm Password',
                                               tabIndex: 2,
                                               type: 'password'
                                           }}
                                    />
                                </div>
                            </div>
                            <footer style={{
                                background: "#2D3436",
                                borderTop: "2px solid #f5f5f5a3",
                                height: 49,
                                width: "100%",
                                paddingRight: 5,
                                paddingTop: 3,
                            }}>
                                <button
                                    onClick={this.inviteUserHandler}
                                    className={"btn"}
                                    id={"btn-set-new-pass"}
                                    style={{float: "right", marginTop: 3, marginLeft: 4}}>
                                    <i className="fas fa-save"> Submit</i>
                                </button>
                                <button
                                    onClick={this.close}
                                    className={"btn"}
                                    style={{float: "right", marginTop: 3, marginRight: 2}}>
                                    <i className="fas fa-times"> Close</i>
                                </button>
                            </footer>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}

export default SetUserPasswordModal



// WEBPACK FOOTER //
// ./app/components/bo-core/grids/UsersGrid/components/setPasswordModal/SetUserPasswordModal.tsx